import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async/index'
import {fetchRlStandardSets} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {useSchoolAdmin} from '@freckle/school/ts/hooks/use-school-admin'
import {SettingsComponentContainer} from '@freckle/school/ts/settings/components/settings-container'

export default function SettingsComponentHandler() {
  const schoolAdmin = useSchoolAdmin()
  const mathStandardSets = useAsync(
    () => fetchRlStandardSets({'content-area': 'math'}),
    'fetchRlStandardSets',
    ['math']
  )

  return (
    <WithResources
      resources={{schoolAdmin, mathStandardSets}}
      render={({schoolAdmin, mathStandardSets}) => (
        <SettingsComponentContainer schoolAdmin={schoolAdmin} mathStandardSets={mathStandardSets} />
      )}
    />
  )
}
